import { Api } from 'models/services/api';
import { ReadIngredientsQuery } from 'models/services/graphql';

import { IngredientCollectionData } from '../collection';

type DataToFetch = {
  dishItemId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadIngredients($dishItemId: ID!, $nextToken: String) {
    ${ReadIngredientsQuery}
  }
`;

type ResponseData = {
  data: {
    readIngredients: IngredientCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: IngredientCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readIngredients;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
export type { DataToFetch as ReadCollectionGqlDataToFetch }
